import { render } from "./TermsView.vue?vue&type=template&id=b493d666&scoped=true"
const script = {}

import "./TermsView.vue?vue&type=style&index=0&id=b493d666&lang=css&scoped=true"

import exportComponent from "/home/runner/work/Frontend_PsicoApp/Frontend_PsicoApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b493d666"]])

export default __exports__